import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';
import { format } from 'date-fns';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

import type { Workstream } from '../entities/workstream';

export namespace EditWorkstreamMutation {
  export type Input = {
    id: string;
    update: Pick<Workstream, 'name' | 'description' | 'startDate' | 'endDate'>;
  };
  export type Output = void;

  function useMutationFn() {
    const editWorkstream = useInjectFeApiContext(
      FeApi.tasksV1WorkstreamsUpdateUpdate,
    );

    return async function mutationFn(input: Input) {
      await ok(
        editWorkstream({
          uuid: input.id,
          updateWorkstreamViewInputRequest: {
            name: input.update.name,
            description: input.update.description,
            start_date: format(input.update.startDate, 'yyyy-MM-dd'),
            end_date: format(input.update.endDate, 'yyyy-MM-dd'),
          },
        }),
      );
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['project-management'],
        });
      },
    });
  }
}
